<template>
  <v-row class="mt-4">

    <v-col class="mr-4">
      <router-link to="/asset">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-application-edit-outline mb-2" style="font-size: 50px;height: 58px;" color="#222"/>
          <v-col class="pt-0">
            동영상 관리 
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/playlist">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-arrow-right-drop-circle-outline mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            플레이리스트
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/wowzastream/wowzalivestream_create">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-access-point mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            라이브 관리
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <v-col class="mr-4">
      <router-link to="/statistics">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-chart-bar mb-2" style="font-size: 50px;height: 58px;" color="#222"/>
          <v-col class="pt-0">
            통계
          </v-col>
        </v-card>
      </router-link>
    </v-col>
    <!-- <v-col class="mr-4">
      <router-link to="/frontmg/frontmg-create">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-laptop mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            템플릿
          </v-col>
        </v-card>
      </router-link>
    </v-col> -->
    <!-- <v-col class="mr-4">
      <router-link to="/social-upload">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-cast mb-2" style="font-size: 50px;height: 58px;" color="#222"/>
          <v-col class="pt-0">
            소셜 업로드
          </v-col>
        </v-card>
      </router-link>
    </v-col> -->
    <v-col>
      <router-link to="/admin/user">
        <v-card class="text-center pa-4" outlined link>
          <v-icon class="mdi mdi-cog-outline mb-2" style="font-size: 58px;" color="#222"/>
          <v-col class="pt-0">
            설정
          </v-col>
        </v-card>
      </router-link>
    </v-col>
  </v-row>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped></style>